import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { DatasetService } from 'src/app/services/dataset.service';

@Component({
  selector: 'app-list-datasets',
  templateUrl: './list-datasets.component.html',
  styleUrls: ['./list-datasets.component.scss']
})
export class ListDatasetsComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  @Input() accountId: any;
  @Input() enrollmentId: any;
  @Output() dataEvent = new EventEmitter<any>();
  dataSetList: DataSetList[] = [];
  dataSetForm!: FormGroup;
  dataSetFileList:any = [];


  constructor(private dataSetService: DatasetService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.route.params
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(params => {
        this.accountId = params['accountId'];
        this.getDataSetById(params['accountId']);
      });
      this.dataSetForm = this.formBuilder.group({
            datasetFile: new FormControl('', [Validators.required])
      });

  }

  getDataSetById(id: string) {
    this.dataSetService.getDataSetListByID(id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        if (result?.responseData) {
          this.dataSetList = result.responseData.datasets;
        }
      },
    () => {
      this.dataSetList = [];
    });
      this.getDatasetList();
  }

    validate(): void {
      if (this.dataSetForm.invalid) {
        for (const control of Object.keys(this.dataSetForm.controls)) {
          this.dataSetForm.controls[control].markAsTouched();
        }
        return;
      }
      const fileName = this.dataSetForm.controls['datasetFile'].value;
      this.dataEvent.emit('{"fileName":"'+fileName+'"}');
    }

    getDatasetList() {
      this.dataSetService.getUploadedDataSetFiles(this.accountId, this.enrollmentId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        if (result?.responseData) {
          this.dataSetFileList = result.responseData.dataSources;
        }
      });
    }

    datasetIdtoParent(dataSetId: number) {
      this.dataEvent.emit('{"dataSetId":'+dataSetId+'}');
    }
  



  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
